import { render, staticRenderFns } from "./AccessModal.vue?vue&type=template&id=208f9939&scoped=true"
import script from "./AccessModal.vue?vue&type=script&lang=js"
export * from "./AccessModal.vue?vue&type=script&lang=js"
import style0 from "./AccessModal.vue?vue&type=style&index=0&id=208f9939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f9939",
  null
  
)

export default component.exports